export default "__VITE_ASSET__BDAryNt8__"